module.exports = __webpack_public_path__ + "img/video.e91f614f.png";